/**
 * Validate fields for containing valid email addresses (and not empty)
 *
 * @param {string} input - the value of the field being validated
 * @return {boolean} isValid - does the input value pass the test
 */
function emailValidator(input) {
  const regexpTest = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const isValid = regexpTest.test(input) && input.length > 0;

  return isValid;
}

export default emailValidator;



// WEBPACK FOOTER //
// ./scripts/util/validation/emailValidator.js